<template>
  <div class="register-page-container">

    <v-progress-circular
      v-show="loading"
      id="progress"
      :size="80"
      :width="3"
      color="primary"
      indeterminate
    />

    <div v-show="!loading"
         class="register-page">

      <div class="register-headerline">
      <span class="ueberplus primary--text">
        {{ !confirmMessage ? 'Registrieren Sie sich bei der DMB Rechtsschutz' : 'Ihre Registrierung wurde erfasst' }}
      </span>
      </div>

      <template v-if="!confirmMessage">
      <span class="info-text">Nach der Registrierung erhalten Sie umgehend eine E-Mail mit Ihren persönlichen Anmeldedaten. Im Portal haben Sie als Makler dann sofort Zugriff
          auf alle Produkt- und Vermittlerinformationen, Vertrags- und Schadendaten sowie auf den Produktabschluss.</span>

        <span class="info-text">Hinweise zur Verarbeitung Ihrer personenbezogenen Daten entnehmen Sie bitte unserer
         <a :href="datenschutzUrl"
            target="_blank">Datenschutzerklärung
         </a>.
        </span>

        <edit-section :keys="['loginname']"
                      :user="user"
                      register-mode
                      title="Benutzerkonto">
          <template slot-scope="slotProps">
            <edit-account :user-form="slotProps.userForm" />
          </template>
        </edit-section>

        <edit-section :keys="['anrede', 'titel', 'vorname', 'nachname', 'staat', 'geburt']"
                      :user="user"
                      register-mode
                      title="Person">
          <template slot-scope="slotProps">
            <edit-person :user-form="slotProps.userForm" />
          </template>
        </edit-section>

        <edit-section :keys="['firma', 'rechtsform', 'maklerverbund', 'gruendungsjahr', 'dihk', 'dihkrechte', 'avad']"
                      :user="user"
                      register-mode
                      title="Unternehmen">
          <template slot-scope="slotProps">
            <edit-firma :user-form="slotProps.userForm"
                        register-mode />
          </template>
        </edit-section>

        <edit-section :keys="['email', 'tel', 'fax', 'mobile']"
                      :user="user"
                      register-mode
                      title="Kontakt">
          <template slot-scope="slotProps">
            <edit-kontakt :user-form="slotProps.userForm"
                          @mailChange="defaultMail = arguments[0]" />
          </template>
        </edit-section>

        <edit-section :keys="['strasse', 'hausnummer', 'adresszusatz', 'plz', 'ort', 'postfach', 'pplz']"
                      :user="user"
                      register-mode
                      title="Adresse">
          <template slot-scope="slotProps">
            <edit-adresse :user-form="slotProps.userForm" />
          </template>
        </edit-section>

        <edit-section :keys="['ktoiban', 'ktobic', 'ktoinhaberanderer', 'ktoinhaberanrede', 'ktoinhabertitel', 'ktoinhabervorname',
                      'ktoinhabernachname', 'ktoinhaberstrasse', 'ktoinhaberhausnummer', 'ktoinhaberadresszusatz',
                      'ktoinhaberplz', 'ktoinhaberort']"
                      :user="user"
                      register-mode
                      title="Bankverbindung">
          <template slot-scope="slotProps">
            <edit-bank :user-form="slotProps.userForm" />
          </template>
        </edit-section>

        <edit-section :keys="['originalwas', 'kopiewas', 'kopiepost', 'kopieadresse', 'provmail', 'provmailadresse']"
                      :user="user"
                      register-mode
                      title="Versandoptionen">
          <template slot-scope="slotProps">
            <edit-info :user-form="slotProps.userForm"
                       :default-mail="defaultMail" />
          </template>
        </edit-section>

        <div class="ma-0 mt-6"
                  row>
          <v-btn class="ma-0 mr-10"
                 @click="cancel">Abbrechen
          </v-btn>
          <v-btn class="ma-0"
                 color="primary"
                 @click="createUser">Registrieren
          </v-btn>
        </div>

      </template>

      <template v-else>
        <span class="info-text">Sie erhalten in Kürze eine E-Mail mit Ihren persönlichen Anmeldedaten.</span>
        <div class="login-btn">
          <v-btn color="primary"
                 @click="$router.push('/login')">Zum Login
          </v-btn>
        </div>
      </template>

    </div>

    <!-- error message -->
    <v-snackbar v-model="snackbar"
                :timeout="4000"
                color="error"
                bottom
                multi-line>
        <span class="snackbar-message text-center">
          <v-icon color="white">warning</v-icon>
          {{ message }}
        </span>
    </v-snackbar>

  </div>
</template>
<script>
import EditSection from "@/components/userProfile/EditSection";
import EditPerson from "@/components/userProfile/EditPerson";
import EditFirma from "@/components/userProfile/EditFirma";
import EditKontakt from "@/components/userProfile/EditKontakt";
import EditAdresse from "@/components/userProfile/EditAdresse";
import EditAccount from "@/components/userProfile/EditAccount";
import EditBank from "@/components/userProfile/EditBank";
import EditInfo from "@/components/userProfile/EditInfo";
import httpService from "@/helper/httpService";
import {datenschutzUrl} from "@/store/config/externalLinks";

export default {
  name: "RegisterPage",
  components: { EditSection, EditPerson, EditFirma, EditKontakt, EditAdresse, EditAccount, EditBank, EditInfo },
  data() {
    return {
      confirmMessage: false,
      snackbar: false,
      message: '',
      edit: null,
      loading: false,

      defaultMail: "",
      user: {
        anrede: "kA",
        titel: "",
        vorname: "",
        nachname: "",
        staat: "Deutschland",
        geburt: "",
        firma: "",
        rechtsform: null,
        maklerverbund: null,
        gruendungsjahr: "",
        dihk: "",
        dihkrechte: "Makler nach § 34d Abs. 1 Nr. 2 GewO",
        loginname: "",
        email: "",
        mobile: "",
        tel: "",
        fax: "",
        strasse: "",
        hausnummer: "",
        adresszusatz: "",
        plz: "",
        ort: "",
        postfach: "",
        pplz: "",
        ktoiban: '',
        ktobic: '',
        ktoinhaberanderer: "0",
        ktoinhaberanrede: "kA",
        ktoinhabertitel: "",
        ktoinhabervorname: "",
        ktoinhabernachname: "",
        ktoinhaberstrasse: "",
        ktoinhaberhausnummer: "",
        ktoinhaberadresszusatz: "",
        ktoinhaberplz: "",
        ktoinhaberort: "",
        //originalwas and kopiewas have to be sums of powers of 2
        originalwas: "0", //which originals to send (always per post), value: 0 to 3
        kopiewas: "31", //which copies to send, value: 0 to 31
        kopiepost: "0", // 1 => per Post, 0 => per Mail
        kopieadresse: "", // kopiepost == 0 => Adresse für Mailversand,
        provmail: "1", // 0 => per Post, 1 => per Mail
        provmailadresse: "", // provmail == 1 => Adresse für Mailversand
        avad: null,
      },
      datenschutzUrl
    };
  },
  computed: {
    formRefs: function () {
      return this.$children.filter(child => !!child.formRef).map(child => child.formRef);
    }
  },
  methods: {
    cancel: function () {
      this.$router.push('/');
    },
    createUser: function () {
      this.user = Object.assign({}, this.user, ...this.formRefs.map(ref => ref.userForm));
      Promise.all(this.formRefs.map(ref => ref.$validator.validateAll()))
        .then(validationResults => {
          if (validationResults.includes(false)) throw new Error('Bitte überprüfen Sie Ihre Eingaben.');
          this.loading = true;
          return httpService.registerNewUser(this.user);
        })
        .then(({ success }) => {
          if (!success) throw new Error('Bitte überprüfen Sie Ihre Eingaben.');
          this.loading = false;
          this.confirmMessage = true;
        })
        .catch((err) => {
          this.loading = false;
          this.showSnackbar(err.message, 'error');
        });
    },
    showSnackbar: function (msg) {
      this.message = msg;
      this.snackbar = true;
    }
  }
};
</script>
<style>
.register-page-container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}

.register-page-container #progress {
  top: 30vh;
}

.register-page {
  max-width: 768px;
  font-size: 16px !important;
}

.register-page .register-headerline {
  margin-top: 56px;
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.register-page .info-text + .info-text {
  display: block;
  padding-top: 16px;
}

.register-page .edit-section + .edit-section {
  margin-top: -16px;
}

.register-page .login-btn {
  margin: 40px 0 0 0;
  display: flex;
  justify-content: center;
}
</style>
